import { createPortal } from 'react-dom';
import './LanguageModal.css';

interface LanguageModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentLanguage: string;
  onLanguageChange: (lang: string) => void;
}

const LanguageModal = ({
  isOpen,
  onClose,
  currentLanguage,
  onLanguageChange
}: LanguageModalProps): JSX.Element | null => {
  if (!isOpen) return null;

  return createPortal(
    <div className={`language-modal ${isOpen ? 'open' : ''}`}>
      <div className="language-modal-content">
        <button
          className="language-modal-close"
          onClick={onClose}
        >
          ×
        </button>
        <h2 className="language-modal-title">言語を選択</h2>
        <div className="language-options">
          <div
            className={`language-option ${currentLanguage === 'ja' ? 'active' : ''}`}
            onClick={() => onLanguageChange('ja')}
          >
            <span className="language-code">JP</span>
            <span className="language-name">日本語</span>
          </div>
          <div
            className={`language-option ${currentLanguage === 'en' ? 'active' : ''}`}
            onClick={() => onLanguageChange('en')}
          >
            <span className="language-code">EN</span>
            <span className="language-name">English</span>
          </div>
          <div
            className={`language-option ${currentLanguage === 'zh-CN' ? 'active' : ''}`}
            onClick={() => onLanguageChange('zh-CN')}
          >
            <span className="language-code">ZHC</span>
            <span className="language-name">简体中文</span>
          </div>
          <div
            className={`language-option ${currentLanguage === 'zh-TW' ? 'active' : ''}`}
            onClick={() => onLanguageChange('zh-TW')}
          >
            <span className="language-code">ZHT</span>
            <span className="language-name">繁體中文</span>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LanguageModal; 